import { HOST_TOOL_NAMES } from "../../turns/turn-constants";
import { describeToolExecute } from "./tool-execute/describe-tool-execute";
import { labelOnly } from "../label-only";
import { toolInput } from "../tool-input";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";

export const integrationToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  [
    HOST_TOOL_NAMES.READ_VERCEL_DEPLOYMENT,
    (record) =>
      labelOnly(
        `Read Vercel deployment for ${toolInput.str(record.sha)?.slice(0, 7) ?? "a commit"}`,
      ),
  ],
  [
    HOST_TOOL_NAMES.PROVISION_SERVICE,
    (record) => {
      const service = toolInput.str(record.service);
      return labelOnly(
        service
          ? `Requested approval to provision ${service}`
          : "Requested approval to provision a service",
      );
    },
  ],
  [
    "tool_search",
    (record) => {
      const query = toolInput.str(record.query);
      return labelOnly(
        query
          ? `Searched integrations for "${toolInput.truncate(query, 60)}"`
          : "Searched the connected integrations",
      );
    },
  ],
  [
    "tool_execute",
    (record, state) => describeToolExecute(record, state.output),
  ],
];
